export default __webpack_public_path__ + "static/media/kanji-aikido.e308cbe6.png";